import React from 'react';

// Tab constants
export const TABS = {
  MATTERS: 'matters',
  QUICK_ACTIONS: 'quickActions',
  LIBRARIES: 'libraries',
  TEAMS: 'teams'
};

function TabNavigation({ activeTab, onTabChange }) {
  // Instead of navigating between pages, call the onTabChange callback
  const handleTabClick = (tab) => {
    if (onTabChange) {
      onTabChange(tab);
    }
  };
  
  return (
    <div className="dashboard-tabs">
      <button 
        className={activeTab === TABS.MATTERS ? 'active' : ''} 
        onClick={() => handleTabClick(TABS.MATTERS)}
      >
        Matters
      </button>
      <button 
        className={activeTab === TABS.QUICK_ACTIONS ? 'active' : ''} 
        onClick={() => handleTabClick(TABS.QUICK_ACTIONS)}
      >
        Quick Actions
      </button>
      <button 
        className={activeTab === TABS.LIBRARIES ? 'active' : ''} 
        disabled
      >
        Libraries
      </button>
      <button 
        className={activeTab === TABS.TEAMS ? 'active' : ''} 
        disabled
      >
        Teams
      </button>
    </div>
  );
}

export default TabNavigation;